import { observer } from 'mobx-react-lite';
import { v4 as uuid } from 'uuid';
import DynamicTableComponent from '../DynamicTable/DynamicTableComponent';
import { useStore } from '../../app/stores/store';
import { useEffect, useState } from 'react';
import { Button, Menu, Segment } from 'semantic-ui-react';
import Components from '../../app/common/components';
import { CRM_Metadata } from '../../app/stores/CRMStore/types';
import LoadingComponent, { ThreeDotLoader } from '../../app/layout/LoadingComponent';
import { toast } from 'react-toastify';
const Logistics = () => {
  const {
    CRMStore: {
      logisticsTable,
      subtaskCompoent,
      handleDeliveryL3,
      logisticsSubtaskGroupDetails,
      buttonShowHandler,
      handleTableDetails,
      handleInwardTable,
      handleOutwardTable,
      subtaskCompoent: { logisticsElements, isModel, selectedItemDetails, selectedRowDetails },
      loader,
      logisticsButton,
      handlelogisticsButton,
      logistictextAreaElementId,
      updateLogisticsTable
    },
    commonStore,
    dashboardStore,
    CRMStore
  } = useStore();
  const [pageNumber, setPageNumber] = useState(1);
  const [selectedSubtask, setSelectedSubtask] = useState<string>('');
  const [subTaskDetails, setSubTaskDetails] = useState<
    {
      subtask: string;
      count: number;
    }[]
  >([]);
  useEffect(() => {
    handleDeliveryL3();
    // eslint-disable-next-line
  }, []);
  useEffect(()=>{
  if(selectedItemDetails?.current_subtask && selectedItemDetails?.current_subtask === 'Deliverables'){
    setSelectedSubtask('OutWard');
  }
  },[selectedItemDetails])
  useEffect(() => {
    if (logisticsSubtaskGroupDetails.length === 0) return;
    const transformedDetails = logisticsSubtaskGroupDetails.map((detail) => ({
      subtask: detail.subtask,
      count: detail.count,
    }));
    setSubTaskDetails(transformedDetails);
    const selectedSubTask = logisticsSubtaskGroupDetails.filter(
      (s) => s.count !== 0,
    );
    setSelectedSubtask(selectedSubTask?.[0]?.subtask || 'InWard');
    // eslint-disable-next-line
  }, [logisticsSubtaskGroupDetails]);

  useEffect(() => {
    if (selectedSubtask === '') return;
    if (selectedSubtask === 'InWard') {
      handleInwardTable(1);
    } else {
      handleOutwardTable(1);
    }
    setPageNumber(1)
    // eslint-disable-next-line
  }, [selectedSubtask]);

  const paginateFunction = (e: number) => {
    if (selectedSubtask === 'InWard') {
      handleInwardTable(e);
    } else {
      handleOutwardTable(e);
    }
    dashboardStore.setTagPageNumFunc(e);
    setPageNumber(e);
  };
  const searchFunction = (column: any, order: any) => {
    console.log(order, column);
  };
  const onChangeHandler = (
    e: any,
    { value }: { value: string },
    elements: CRM_Metadata,
  ) => {
    //  let errorTemp = Object.assign({}, errorMessage);
    const localElement = [...subtaskCompoent.logisticsElements];
    const index = localElement.findIndex(
      (x) => x.elementName === elements.elementName,
    );
    localElement[index].elementValue = value;
    subtaskCompoent.logisticsElements = localElement;
  };

    const handleDeliveryTable = async (name:string) => {
    if(selectedRowDetails?.id === '') {
      toast.error('Please select row.')
    }
    handlelogisticsButton()
      const data: any = logistictextAreaElementId.filter(
        (e) => e.itemId === selectedRowDetails.id && e.name === name
      )[0].templateDatails;
      const elements = logisticsElements.filter(
        (e) => e.elementId === data.elementId,
      )?.[0];
      await updateLogisticsTable(selectedRowDetails.id, name, {
        id: elements.elementId,
        value: elements.elementValue,
      });
      if (name === 'InWard') {
        CRMStore.activePage = 'Process';
        
      }
    };

    
  return (
    <div>
            {dashboardStore.dashboard.loadingdata === 'loading' || 
      // eslint-disable-next-line
     loader.tableLoader ? <LoadingComponent/> : <></>}
   {/* // eslint-disable-next-line */}
      <Segment style={{display:'flex',justifyContent:'space-between'}}>
        <div className="newProductionPlanning-wrapper">
          <div>
            {subTaskDetails?.length !== 0 && (
              <Menu
                style={{
                  padding: '5px',
                  height: '47px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px',
                    flexWrap: 'wrap',
                  }}
                >
                  {!subTaskDetails?.length ? (
                    <h4>Sorry No Data</h4>
                  ) : (
                    subTaskDetails.map(({ subtask, count }) => (
                      <button
                        style={{ height: '10px' }}
                        onClick={() => {
                          setSelectedSubtask(subtask);
                          buttonShowHandler();
                          CRMStore.authorizationModel = true;
                          subtaskCompoent.isModel = false;
                          handleTableDetails(
                            1,
                            'Film Digitization Workflow',
                            subtask,
                          );
                        }}
                        className={
                          count === 0
                            ? 'disabled'
                            : selectedSubtask === subtask
                              ? 'selected'
                              : ''
                        }
                        disabled={count === 0}
                      >{`${subtask} (${count})`}</button>
                    ))
                  )}
                </div>
              </Menu>
            )}
          </div>
        </div>
        <div>
        {logisticsButton.inWard || logisticsButton.outWard  ? (
              <>
                {loader.buttonLoader ? (
                  <div
                    style={{
                      position: 'relative',
                      width: '40px',
                      height: '48px',
                    }}
                  >
                    <ThreeDotLoader />
                  </div>
                ) : (
                  <>
                    {logisticsButton.inWard && (
                      <Button
                        onClick={() =>
                          handleDeliveryTable('InWard')
                        }
                        color="green"
                      >
                        Move
                      </Button>
                    )}
                    {logisticsButton.outWard && (
                      <Button.Group floated="right">
                        <Button
                          color="green"
                          onClick={() =>
                            handleDeliveryTable('OutWard')
                          }
                        >
                         Delivery
                        </Button>
                      </Button.Group>
                    )}
                  </>
                )}
              </>
            ) : null}
        </div>
      </Segment>
      <Segment>
      <DynamicTableComponent
        key={uuid()}
        data={logisticsTable.tableData}
        name={`CRM ${selectedSubtask.charAt(0).toUpperCase() + selectedSubtask.slice(1)}`}
        actiontype={''}
        pageFunc={paginateFunction}
        pageNumData={pageNumber}
        searchFuncData={searchFunction}
      />
      </Segment>
      {isModel ? (
        <Segment>
          <div style={{ marginLeft: '25%' }}>
            {logisticsElements
              ?.filter(() => {
                return true;
              })
              ?.sort((a, b) => {
                if (a.elementIndex < b.elementIndex) return -1;
                if (a.elementIndex > b.elementIndex) return 1;
                return 0;
              })
              ?.map((elem: any, index: number) => {
                return (
                  <>
                    <Components
                      elementDetails={elem}
                      disabled={commonStore.filterModeZero?.includes(
                        elem.templateElementId,
                      )}
                      index={index}
                      templateId={elem.templateElementId || ''}
                      onChangeHandler={onChangeHandler}
                      RoleChecker={false}
                      onPhotoClick={() => {}}
                      getUploadedFiles={() => {}}
                      onConfirmUser={() => {}}
                      name={'CRM SmartFlow'}
                    />
                  </>
                );
              })}
          </div>
        </Segment>
      ) : null}
    </div>
  );
};
export default observer(Logistics);
